<template>
  <container
    :subHeaderTitle="serviceType"
    subHeaderText="휴대폰으로 전송된 인증번호를 입력해주세요."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>인증번호</p>
              <div class="d-flex">
<!--                <v-text-field
                  v-if="teleCoCd == '3'"
                  ref="certNum"
                  label="인증번호 입력"
                  mask="########"
                  :rules="rules.certNumLgTRules"
                  v-model="certNum"
                  v-bind:suffix="countdown"
                  required
                  solo
                />-->
                <v-text-field
                  ref="certNum"
                  label="인증번호 입력"
                  mask="#####"
                  :rules="rules.certNumRules"
                  v-model="certNum"
                  :suffix="countdown"
                  required
                  solo
                />
                <v-btn large depressed class="ml-2 resend" @click.stop="sendSmsCert"
                :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >재전송</v-btn>
              </div>
              <div class="pl-5 mt-2 mb-12">
                <ul>
                  <li>인증번호는 3분 이내에 입력하셔야 합니다.</li>
                  <li>인증시간이 초과하면 재전송하여 인증하시기 바랍니다.</li>
                </ul>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >확인</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label3" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 인증번호 인증 실패 -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증번호가 일치하지 않습니다.<br />전송된 인증번호를 확인해보세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="dialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 처리결과 다이얼로그 -->
    <v-dialog v-model="resultDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적으로 처리되지 않았습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goNext()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 시간제한 지났을때 -->
    <v-dialog v-model="countDownOverDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증시간이 초과했습니다.<br />인증번호를 재전송하여 인증해주세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="countDownOverDialog = !countDownOverDialog">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "~@/styles/cscenter";

/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
</style>

<script>
import Container from "@/pages/container/index.vue";
import { CONSTANS } from "@/const/index.js";
import { GaTracking, generateSHA256Hash, formater } from "@/mixins/index.js";

export default {
  mixins: [GaTracking, generateSHA256Hash, formater],
  name: "PassPrimeCert",
  components: {
    Container
  },
  data: ()  => ({
    valid: false,
    type: "", //: "contract", teleCoCd: "2", cellTelNo: "12312312312"
    teleCoCd: "",
    cellTelNo: "",
    birth: "",
    genCd: "",
    name: "",
    certNum: "",
    prdtNo: "P001",
    chanCd: "F100",
    agreeInfoList: [],
    formHasErrors: false, // validation
    dialog: false,
    progressDialog: false,
    resultDialog : false,
    returnDialog : false,
    countDownOverDialog: false,
    rules: {
      requiredCertNum: value => !!value || "인증번호를 입력하세요.",
      certNumRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
            (v &&
                v.length >= 5 &&
                /([0-9]{5})$/.test(v)) ||
            "인증번호가 정확하지 않습니다."
      ],
      certNumLgTRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
            (v &&
                (v.length >= 8 ||v.length == 5) &&
                /([0-9]{5})|([0-9]{8})$/.test(v)) ||
            "인증번호가 정확하지 않습니다."
      ]
    },
    //timer
    countdown: "3:00",
    endTime: "",
    hours: "",
    mins: "",
    msLeft: "",
    time: ""
  }),
  computed: {
    serviceType() {
      return this.type === "contract" ? "PASS프라임<br /><b>가입하기</b>" : "PASS프라임<br /><b>해지하기</b>";
    }
  },
  methods: {
    sendSmsCert(e) {
      if(e != undefined && e != null){
        this.gaTracking(e);
      }
      if(this.teleCoCd == "1") {
        this.prdtNo = "P001"; // PRIME은 SKT만 있음
      } else if(this.teleCoCd == "2") {
        this.prdtNo = "P003";
      } else if(this.teleCoCd == "3") {
        this.prdtNo = "P002";
      }

      this.axios
          .post("/primeRest/sendSmsCert", {
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo,
            prdtNo: this.prdtNo,
            chanCd: this.chanCd,
          })
          .then(result => {
            this.posts = result.data;
            this.countdowns("countdown", 3, 0);
          })
          .catch(result => {
            // console.log("ERROR ", result);
            //this.countdowns("countdown", 3, 0);
          });
    },
    countdowns(elementName, minutes, seconds) {
      this.minutes = minutes;
      this.seconds = seconds;
      this.endTime =
          +new Date() + 1000 * (60 * this.minutes + this.seconds) + 500;
      this.updateTimer();
    },
    updateTimer() {
      this.msLeft = this.endTime - +new Date();
      if (this.msLeft < 1000) {
        this.countdown = "0:00";
      } else {
        this.time = new Date(this.msLeft);
        this.hours = this.time.getUTCHours();
        this.mins = this.time.getUTCMinutes();
        this.countdown =
            (this.hours
                ? this.hours + ":" + this.twoDigits(this.mins)
                : this.mins) +
            ":" +
            this.twoDigits(this.time.getUTCSeconds());
        setTimeout(this.updateTimer, this.time.getUTCMilliseconds() + 500);
      }
    },
    twoDigits(n) {
      return n <= 9 ? "0" + n : n;
    },
    submit(e) {
      this.gaTracking(e);
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;
      
      if (this.countdown === "0:00") {
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      } 
      
      // 가입 / 해지
      let requestPath, requestBody;
      if (this.type === "contract") {
        requestPath = "/primeRest/regCust";
        requestBody = {
            cellTelNo: this.cellTelNo,
            teleCoCd: this.teleCoCd,
            prdtNo: this.prdtNo,
            chanCd: this.chanCd,
            certNum: this.certNum,
            agreeInfoList : this.agreeInfoList
        }
      } else {
        requestPath = "/primeRest/termiCust";
        requestBody = {
          cellTelNo: this.cellTelNo,
          teleCoCd: this.teleCoCd,
          prdtNo: this.prdtNo,
          chanCd: this.chanCd,
          certNum: this.certNum,
          custNm: this.name,
          birthDe: this.birth,
          genCd: this.genCd
        }
      }
      this.axios
        .post(requestPath, requestBody)
        .then((result) => {
          this.progressDialog = false;
          if (result.data.resultCode === "S0000") {
            const date = this.formatDate(new Date(), "YYYYMMDDHHmmssSSS");

            if (this.type === "contract") {
              this.$gtag.purchase({
                transaction_id: this.generateSHA256Hash(this.cellTelNo) + date,
                value: CONSTANS.PR_PRICE,
                currency: "KRW",
                items: [
                  {
                    item_id: CONSTANS.PR_CHAN_CD,
                    item_name: CONSTANS.PR_CHAN_CD,
                    item_variant: CONSTANS.TELE_CO_CD_NM[this.teleCoCd]
                  }
                ]
              });
            }
            this.$router.push({
              name: "PassPrimeResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else if (result.data.resultCode === "E9990") {
            this.dialog = true;
          } else {
            this.goNext();
          }
        })
        .catch((err) => {
          this.progressDialog = false;
          this.goNext();
        });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({ name: "PassPrimeResult", params: { type: this.type, result: "FAIL" } });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.go(-1);
    }
  },
  created() {
    this.type = this.$route.params.type;
    this.teleCoCd = this.$route.params.teleCoCd;
    this.cellTelNo = this.$route.params.cellTelNo;
    this.birth = this.$route.params.birth;
    this.genCd = this.$route.params.genCd;
    this.name = this.$route.params.name;
    this.chanCd = this.$route.params.chanCd ? this.$route.params.chanCd : "F100";
    this.agreeInfoList = this.type === 'contract'? [...this.$route.params.agreeInfoList] : null;
    if(this.type == undefined){
      this.returnDialog = true
    }
  },
  mounted() {
    // console.log("aasdasd");
    this.sendSmsCert(null);
  },
};
</script>